<template>
  <div class="content">
    <Loader v-if="saving" />
    <h1>Product troubleshoot</h1>

    <div>
      <Tabs :tabs="tabs" v-model="active_tab" v-on:change="tabChanged" />
    </div>

    <div>
      <div>
        <div class="small-padding-right small-padding-bottom">
          <p class="bold">Product EAN (one per line):</p>
          <textarea name="productIds" cols="30" rows="10" v-model="products"></textarea>
        </div>
      </div>
      <div>
        <div v-show="active_tab === 'delete_ean'">
          <div class="small-margin-top">
            <button v-on:click="deleteEanFromWordpress()" class="btn-sm">Remove</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.width-half {
  width: 50%;
}
.hand {
  cursor: pointer;
}
</style>

<script>

import Vue from "vue";
import TagSelector from '@/components/TagSelector.vue'
import _ from 'lodash'

export default {
  components: {
    TagSelector
  },
  data: () => ({
    products: '',
    saving: false,
    active_tab: 'delete_ean'
  }),
  computed: {
    tabs () {
      return {
        delete_ean: {
          name: 'Remove EAN from Wordpress'
        }
      }
    }
  },
  methods: {
    deleteEanFromWordpress () {
      if (!this.validateProductSelection()) {
        return;
      }
      const productEans = this.parseProductId();
      productEans.forEach((ean) => {
        Vue.$api.delete('/product/ean/' + ean + '/wp', {}, {
          before: () => this.saving = true,
          always: () => this.saving = false,
          callback: data => this.deleted(data)
        })
      });
    },
    validateProductSelection() {
      if (!confirm('Are you sure of those changes?')) {
        return false;
      }
      if (this.products.length === 0) {
        alert("Product IDs / EAN are required !!")
        return false;
      }
      return true;
    },
    parseProductId() {
      return this.products
        .split('\n')
        .map(id => id.trim())
        .filter(id => id)  // filter out empty strings
        .map(id => parseInt(id));
    },
    tabChanged (tab) {
      switch (tab.id) {
        default:
          break
      }
    },
    deleted() {
      // this.reset();
      this.saving = false
    },
    reset () {
      this.products = ''
    }
  },
  created () {

  }
}
</script>
